import { findAll } from "../utils/dom";


const DataAtual = () =>{
	const datas = findAll('[js-data-atual]');
	if(!datas) return;

	datas?.forEach((data)=>{
		const dataAtual = new Date();
		data.innerText = dataAtual.getFullYear();
	})
}

export default DataAtual;